import { FormEvent, useRef, useState } from 'react';
import { t } from '../hooks/useT';

interface GuessFormProps {
  /** Résout à true si correct, false si mauvaise réponse, undefined si erreur réseau */
  onSubmit: (guess: string) => Promise<boolean | void>;
  disabled?: boolean;
}

export function GuessForm({ onSubmit, disabled }: GuessFormProps) {
  const [value, setValue] = useState('');
  const [shaking, setShaking] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const shakeTimer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const triggerWrong = () => {
    setShaking(true);
    clearTimeout(shakeTimer.current);
    shakeTimer.current = setTimeout(() => setShaking(false), 450);
    requestAnimationFrame(() => inputRef.current?.focus());
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const trimmed = value.trim();
    if (!trimmed || disabled) return;

    setValue('');
    try {
      const correct = await onSubmit(trimmed);
      if (correct === false) {
        triggerWrong();
      }
    } catch {
      setValue(trimmed);
      inputRef.current?.focus();
    }
  };

  return (
    <div className="guess-wrap">
      <p className="guess-hint">{t('play.hint')}</p>
      <form
        className={`guess-form${shaking ? ' guess-form--wrong' : ''}`}
        onSubmit={handleSubmit}
      >
        <label htmlFor="guess-input" className="sr-only">{t('play.placeholder')}</label>
        <input
          ref={inputRef}
          id="guess-input"
          type="text"
          autoComplete="off"
          autoCapitalize="off"
          spellCheck={false}
          placeholder={t('play.placeholder')}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          disabled={disabled}
        />
        <button type="submit" disabled={disabled || !value.trim()}>
          {t('play.submit')}
        </button>
      </form>
    </div>
  );
}
